import React from 'react';

interface CustomHeaderProps {
    title: string;
    onClose?: () => void;
    component: React.ElementType;
}

const CustomHeader: React.FC<CustomHeaderProps> = ({ title, onClose, component: Component }) => {
    return (
        <Component
            className="p-3 m-0 border-bottom-0"
            style={{ backgroundColor: '#d19221' }}
        >
            <div className="modal-title mb-0 text-white h5">{title}</div>
            {onClose && (
                <button
                    type="button"
                    onClick={onClose}
                    className="btn p-0 border-0 position-absolute top-0 end-0 m-3"
                    style={{ background: 'transparent' }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>
            )}
        </Component>
    );
};

export default CustomHeader;
